<template>
  <b-container>
    <div>
      <div v-if="form">
        <module-view-form
          :id="item.formId"
          :moduleId="moduleId"
          :itemId="id"
        ></module-view-form>
      </div>
      <div v-else>
        <module-view-bi :id="item.powerBiViewId"></module-view-bi>
      </div>
    </div>
  </b-container>
</template>
<script>
export default {
  name: "ModuleView",
  components: {
    ModuleViewForm: () => import("./ModuleViewForm.vue"),
    ModuleViewBi: () => import("./ModuleViewBi.vue"),
  },
  props: {
    moduleId: String,
    id: String,
  },
  data() {
    return {
      item: [],
      form: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$apiScheduler
        .get("/module/getMenu/" + this.id)
        .then((response) => {
          this.item = response.data;
          console.log("ModuleViw");
          console.log(response.data);
          if (this.item.formId == null) this.form = false;
          if (this.item.powerBiViewId == null) this.form = true;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            console.log(error);
          }
        });
    },
  },
  watch: {
    id() {
      this.loadData();
    },
  },
};
</script>
